<template>
  <div class="user-query-overview-component">
    <PaginatedSharedSignalQueryComponent :user-id="userId"/>
    <PaginatedSignalQueryComponent :user-id="userId" :can-delete-signal="canDeleteSignal"/>
  </div>
</template>

<script>
import store from '~/store';
import signalModule from '../store';
import PaginatedSignalQueryComponent from './PaginatedSignalQueryComponent';
import PaginatedSharedSignalQueryComponent from './PaginatedSharedSignalQueryComponent';

export default {
  name: "UserQueryOverviewComponent",
  components: {
    PaginatedSignalQueryComponent,
    PaginatedSharedSignalQueryComponent,
  },
  props: {
    userId: {
      type: [Number, String],
      required: true
    },
    canDeleteSignal: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {}
  },
  created() {
    if (!store.hasModule('signal')) {
      store.registerModule('signal', signalModule)
    }
  },
}
</script>
